/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Annotations from "App/model/annotations/annotations";
import {RenderElement} from "App/model/elements/element";
import IElement from "js_interface/src/elements/element_interface";

export default
class Annotation {

    private _annotationsRef: Annotations;
    private _data: any;
    private _element: RenderElement = null;

    constructor(aAnnotations: Annotations) {
        this._annotationsRef = aAnnotations;
        this._data = null;
        this._element = null;
    }

    public getParsedUID(): number {
        return this._data.UID;
    }

    public parse(aAnnotationJSON: any): any {
        this._data = aAnnotationJSON;
    }

    public getData(): any {
        return this._data;
    }

    public setElement(aElement: RenderElement) {
        this._element = aElement;
    }

    public getSceneAPIElement(): IElement {
        let sceneElement = null;
        if (this._element) {
            sceneElement = this._element.getSceneAPIElementReference();
            if (!sceneElement) { // if scene api element does not exists for this model element, then we create a general element to be returned
                sceneElement = this._annotationsRef.getModelDescription().getSceneAPI().getDocument().createAPIElement(this._element.getType());
                sceneElement.attachToRenderElement(this._element, this._element.getModel());
            }

        }

        return sceneElement;
    }
}
